/**
*
* PluginSetup
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Link from 'data/Link';
import enhanceWithThemes from 'hocs/enhanceWithThemes';

import Sidebar from 'Workspace/components/WorkspaceSidebar';
import WorkspaceHeader from 'Workspace/components/WorkspaceHeader';
import HomeNavigation from 'Workspace/components/HomeNavigation';
import gtmService from 'utils/gtm/gtmService';

import {
  PageWrapper,
  PageViewport,
} from 'components/PageStyles';
import {
  SetupWrapper,
  SetupHolder,
  StepHeader,
  StepNumber,
  StepTitle,
  ContentWrapper,
} from './styles';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';

import messages from './messages';
import themes from './themes';

class PluginSetup extends React.Component {
  state = {
    step: 1,
    initial: true,
  };

  componentDidMount() {
    if (this.props.location) {
      const { pathname } = this.props.location;
      gtmService.pushTelemetryPageActivityAndView({ pageName: pathname });
    }
  }

  setStep = (step) => this.setState({ step, initial: false });

  next = () => this.setStep(Math.min(3, (this.state.step + 1)));
  back = () => this.setStep(Math.max(1, (this.state.step - 1)));
  goTo = (step) => () => this.setStep(step);

  render() {
    const { match, summary } = this.props;
    const { step, initial } = this.state;

    return (
      <PageWrapper>
        <Sidebar navigation={<HomeNavigation selectedKey="plugins" />} />
        <PageViewport>
          <WorkspaceHeader
            links={[
              new Link('/plugins', 'Plugins'),
              new Link(`/plugins/${match.params.pluginId}`, summary ? summary.name : match.params.pluginId),
            ]}
            title="Setup"
          />
          <SetupWrapper>
            <SetupHolder>
              <StepHeader onClick={this.goTo(1)} >
                <StepNumber active={step === 1} done={step > 1} number={1} />
                <StepTitle>
                  <FormattedMessage {...messages.getStarted} />
                </StepTitle>
              </StepHeader>
              <ContentWrapper>
                <StepOne active={step === 1} instantDisplay={initial} next={this.next} />
              </ContentWrapper>

              <StepHeader onClick={this.goTo(2)}>
                <StepNumber active={step === 2} done={step > 2} number={2} />
                <StepTitle todo={step < 2}>
                  <FormattedMessage {...messages.createAPlugin} />
                </StepTitle>
              </StepHeader>
              <ContentWrapper>
                <StepTwo active={step === 2} back={this.back} next={this.next} />
              </ContentWrapper>

              <StepHeader onClick={this.goTo(3)}>
                <StepNumber active={step === 3} number={3} />
                <StepTitle todo={step < 3}>
                  <FormattedMessage {...messages.uploadYourPlugin} />
                </StepTitle>
              </StepHeader>
              <ContentWrapper lastStep>
                <StepThree active={step === 3} back={this.back} pluginId={match.params.pluginId} />
              </ContentWrapper>
            </SetupHolder>
          </SetupWrapper>
        </PageViewport>
      </PageWrapper>
    );
  }
}

PluginSetup.propTypes = {
  summary: PropTypes.object,
  match: PropTypes.shape({
    params: PropTypes.shape({
      pluginId: PropTypes.string,
    }),
  }),
  location: PropTypes.object,
};

export default enhanceWithThemes(PluginSetup, themes);
